import React from 'react';
import {Box, Typography} from '@mui/material';

export default function PendingUser() {

  return (<Box sx={{position: 'fixed', bottom: { xs: 20, sm: 60 },
      left: '50%', transform: 'translateX(-50%)', zIndex: 999 }}>
    <Typography variant="caption" component="h2" textAlign="center"
      color="warning" sx={{ mb: 1 }} >Admin Approval Pending
    </Typography>
  </Box>);
}
